import { render } from "./sdltgd.vue?vue&type=template&id=c2ed9ae6&scoped=true&ts=true"
import script from "./sdltgd.vue?vue&type=script&lang=ts"
export * from "./sdltgd.vue?vue&type=script&lang=ts"

import "./sdltgd.vue?vue&type=style&index=0&id=c2ed9ae6&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ed9ae6"]])

export default __exports__